import Messages from './messages.js'

/**
 * @typedef {Object} Resolution
 * @property {number} width
 * @property {number} height
 */

/**
 * @typedef {Object} DisplayInfo
 * @property {string} name - The name of the display.
 * @property {Resolution[]} resolutions - The available resolutions for the display.
 * @property {string} connector - The connector type of the display.
 */

export default class DisplayClient {

  constructor(socket) {
    this.socket = socket
  }

  /**
   * Get display info
   * 
   * @returns {Promise<DisplayInfo[]>}
   */
  async getDisplays() {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Display_GetDisplays);
    } catch (error) {
      console.error(`DisplayClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return response.data
  }

  /**
   * Set resolution
   * 
   * @param {Resolution} resolution
   * @returns {Promise<void>}
   */
  async setResolution(resolution) {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Display_SetResolution, resolution);
    } catch (error) {
      console.error(`DisplayClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return
  }
}